<template>
    <div class="uploadDailog_box" v-if="uploadingList.length > 0"
        :style="{
            width:curShowSet.width + 'px'
        }"
    >
        <div class="uploadDailog_body" v-if="!hideFlag">
            <div class="uploadDailog_header">
                <div>上传管理器</div>
                <div class="uploadDailog_iconBtn">
                    <i class="iconfont icon-a-Group1166" @click="showOrHideFunc(true)"></i>
                    <i class="iconfont icon-close1"  @click="cancelAllUpload"></i>
                </div>
            </div>
            <div class="uploadDailog_itemList">
                <div class="uploadDailog_item" v-for="item,index of uploadingList" :key="index">
                    <div class="uploadDailog_itemLeft">
                        <div class="uploadDailog_itemType">
                            <img :src="imgName[item.type] || require('@img/common/noe.png')" alt="">
                        </div>
                        <div class="uploadDailog_itemInfo">
                            <div>{{item.name}}</div>
                            <div v-if="item.size >= 1024000">
                                {{(item.uploadSize/1024000).toFixed(2)}}MB/{{(item.size/1024000).toFixed(2)}}MB
                            </div>
                            <div v-else>
                                {{(item.uploadSize/1024).toFixed(2)}}KB/{{(item.size/1024).toFixed(2)}}KB
                            </div>
                        </div>
                    </div>
                    <div class="uploadDailog_itemRight">
                        <div class="uploadDailog_itemProess">
                            <img v-if="item.status == 'UPLOADING'" class="loading" :src="require('@img/common/loading.png')" alt="">
                            <i @click="startUploading(item)" v-if="item.status == 'STOPING' || item.status == 'STOP'" class="iconfont icon-anniu1 yellow"></i>
                            <i v-if="item.status == 'WAITING'" class="iconfont icon-waitting3 yellow"></i>
                            <i v-if="item.status == 'FINISHED'" class="iconfont icon-active4 green"></i>
                            <i v-if="item.status == 'ERROR'" class="iconfont icon-guanbi red"></i>
                            <span v-if="item.status == 'STOPING'">正在暂停</span>
                            <span v-if="item.status == 'ERROR'">上传失败</span>
                            <span v-else>{{((item.uploadSize/item.size)* 100).toFixed(2)}}%</span>
                        </div>
                        <div class="uploadDailog_itemBtn">
                            <img @click="stopUploading(item)" v-if="item.status == 'UPLOADING' || item.status == 'WAITING'" :src="require('@img/common/stop.png')" alt="">
                            <img @click="startUploading(item)" v-if="item.status == 'STOPING' || item.status == 'STOP'" :src="require('@img/common/start.png')" alt="">
                            <i  @click="startUploading(item)" v-if="item.status == 'ERROR'" class="iconfont icon-reload1"></i>
                            <i  @click="toPreViewFile(item)" v-if="item.status == 'FINISHED'" class="iconfont icon-read3"></i>
                            <img @click="delUploading(item,index)" :src="require('@img/common/close.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="uploadDailog_bottomBox">
                <div class="uploadDailog_loading" v-if="isUploading">
                    <img :src="require('@img/common/loading.png')" alt="">
                    上传中 {{curUploadIndex}}/{{uploadingList.length}}
                </div>
                <div class="uploadDailog_loading" v-else>
                    <span v-if="isFinished">
                        <i class="iconfont icon-active4 green"></i>
                        已完成
                    </span>
                    <span v-else>
                        <i class="iconfont icon-waitting3 yellow"></i>
                        待上传
                    </span>
                </div>
                <div class="uploadDailog_bottomBtn">
                    <div @click="startAllUpload" v-if="isAllStop">全部开始</div>
                    <div @click="stopAllUpload" v-if="!isAllStop">全部暂停</div>
                    <div @click="cancelAllUpload">全部取消</div>
                </div>
            </div>
        </div>
        <div class="uploadDailog_body_hide" v-if="hideFlag">
            <div class="uploadDailog_loading" v-if="isUploading">
                <img :src="require('@img/common/loading.png')" alt="">
                上传中 {{curUploadIndex}}/{{uploadingList.length}}
            </div>
            <div class="uploadDailog_loading" v-else>
                <span v-if="isFinished || uploadingList.length == 0">
                    <i class="iconfont icon-active4 green"></i>
                    已完成
                </span>
                <span v-else>
                    <i class="iconfont icon-waitting3 yellow"></i>
                    待上传
                </span>
            </div>
            <div class="uploadDailog_iconBtn">
                <i class="iconfont icon-arrow-down-new" @click="showOrHideFunc(false)"></i>
                <i class="iconfont icon-close1" @click="cancelAllUpload"></i>
            </div>
        </div>
        <previewPortal v-model="showPreView" :preViewIndex="0" :preViewList="fileList"></previewPortal>
    </div>
</template>

<script>
import previewPortal from 'qs3_pc_common/src/preview/previewPortal.vue'
export default {
    components:{
         previewPortal,
    },
    props: {
      dlgVs: {
        type: Boolean,
        default: function() {
          return false
        }
      }
    },
    data() {
      return {
            hideFlag:false,
            bool:true,
            uploadingList:[],
            curUploadIndex:0,
            isUploading:false,
            isFinished:false,
            isEnd:false,
            curShowSet:{
                width:440,
            },
            imgName:{
                'doc':require('@img/common/doc.png'),
                'txt':require('@img/common/noe.png'),
                'docx':require('@img/common/doc.png'),
                'xlsx':require('@img/common/xls.png'),
                'xlsm':require('@img/common/xls.png'),
                'ppt':require('@img/know/ppt.png'),
                'pptx':require('@img/know/ppt.png'),
                'xls':require('@img/common/xls.png'),
                'pdf':require('@img/common/pdf.png'),
                'mp3':require('@img/common/mp3.png'),
                'mp4':require('@img/common/mp4.png'),
                'avi':require('@img/common/mp4.png'),
                'zip':require('@img/common/zip.png'),
                'rar':require('@img/common/zip.png'),
                'jpg':require('@img/common/img.png'),
                'png':require('@img/common/img.png'),
                'gif':require('@img/common/img.png'),
                'jpeg':require('@img/common/img.png'),
            },
            isAllStop:false,
            stopObj:{},
            showPreView:false,
            fileList:[]
      };
    },
    mounted() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeUnmount() {
        this.cancelUpload()
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    watch: {
      dlgVs: {
        handler() {
            
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
        handleBeforeUnload() {
            this.cancelUpload()
        },
        showOrHideFunc(bool){
            this.hideFlag = bool
            if(bool){
                this.curShowSet.width = 240
            }
            else{
                this.curShowSet.width = 440
            }
        },
        bigUpload(file,uploadType){
            function sliceFile(file, start, end) {
                // 检查浏览器是否支持File.slice()方法
                if (file.slice) {
                    return file.slice(start, end);
                } else if (file.mozSlice) { // 兼容Firefox
                    return file.mozSlice(start, end);
                } else if (file.webkitSlice) { // 兼容Chrome和Safari
                    return file.webkitSlice(start, end);
                }
                return null;
            }
            return new Promise((resove,reject) => {
                this.isEnd = false
                // 切分文件
                const chunkSize = 1000 * 1024 * 6;
                // const chunkSize = 2000;
                let start = 0; 
                let end = Math.min(chunkSize,file.size);
                let chunkObj = {}
                let chunkSplit = []
                let lenght = 0
                while (start < file.size) {
                    const chunk = sliceFile(file, start, end);
                    let obj = {
                        "fc_range": `${start}-${end}`,
                        "fc_size": chunk.size,
                    }
                    chunkObj[`${start}-${end}`] = chunk
                    chunkSplit.push(obj);
                    lenght ++;
                    start = end; 
                    end = start + chunkSize;
                }
                let params = {
                    "lfName": file.name,
                    "lfSize": file.size,
                    "lfSuffix": file.name.split(".")[file.name.split(".").length - 1],
                    "lfType": file.type||file.name.split(".")[file.name.split(".").length - 1],
                    "lfChunkSize": chunkSize,
                    "lfTotalChunks": lenght,
                    "lfUploadType": uploadType,
                    "fileChunks": JSON.stringify(chunkSplit),
                    'isDownload':true,
                }
                if(file.name.split(".")[file.name.split(".").length - 1] == 'pdf'){
                    params['isDownload'] = false
                }
                let formObj = new FormData();
                for(let key in params){
                    formObj.append(key,params[key]);
                }

                this.$http.post(this.$api.file.startUpload,formObj).then(res=>{
                    let bolbObj = {}
                    for(let bItem of res.payload.chunkList){
                        bolbObj[bItem.fc_id] = chunkObj[bItem.fc_range]
                    }
                    let uploadItem = {
                        name:file.name,
                        type:file.name.split(".")[file.name.split(".").length - 1],
                        size:file.size,
                        uploadSize:0,
                        status:'WAITING',
                        fileId:res.payload.lfId,
                        curChunkId:res.payload.fcId,
                        chunkList:res.payload.chunkList,
                        bolbObj:bolbObj
                    }
                    this.uploadingList.push(uploadItem)
                    this.curShowSet.width = 440
                    this.hideFlag = false
                    if(!this.isUploading){
                        uploadItem.status = 'UPLOADING'
                        this.curUploadIndex = this.uploadingList.length
                        this.formalUpload(this.uploadingList[this.curUploadIndex - 1],res.payload.fcId)
                    }
                    resove(res.payload.lfId)
                }).catch((res)=>{
                    reject(res)
                })
            })
        },
        formalUpload(item,chunkId){
            if(this.isEnd){
                return 
            }
            this.isUploading = true
            item.status = 'UPLOADING'
            let formObj = new FormData();
            formObj.append("fcData",item.bolbObj[chunkId]);
            formObj.append("fcId",chunkId);
            formObj.append("scene",'bigFile');
            this.$http.post(this.$api.file.formalUpload,formObj
            ).then(res=>{
                if(res.payload.isEnd){
                    item.uploadSize = item.size
                    item.status = 'FINISHED'
                    this.isUploading = false
                    let nextIndex = this.curUploadIndex
                    if(this.uploadingList[nextIndex]){
                        this.curUploadIndex ++
                        this.formalUpload(this.uploadingList[nextIndex],this.uploadingList[nextIndex].curChunkId)
                    }
                    else{
                        this.autoUploadNew()
                    }
                }
                else{
                    item.uploadSize += res.payload.chunkSize
                    item.curChunkId = chunkId
                    if(!this.stopObj[item.fileId]){
                        this.formalUpload(item,res.payload.fcId)
                    }
                    else{
                        item.status = 'STOP'
                        this.autoUploadNew()
                    }
                }
            }).catch(()=>{
                item.status = 'ERROR'
                this.autoUploadNew()
            })
        },
        cancelAllUpload(){
            if(!this.isFinished){
                this.$confirm('仍有文件未上传成功,取消上传会导致文件预览失败，是否继续?', '取消上传', {
                    confirmButtonText: '取消上传',
                    cancelButtonText: '继续上传',
                    type: 'error'
                }).then(() => {
                    this.curShowSet.width = 0
                    this.curUploadIndex = 0
                    this.isEnd = true
                    this.hideFlag = true
                    this.isUploading = false
                    this.isFinished = false
                    setTimeout(()=>{
                        this.uploadingList = []
                    },250)
                    this.cancelUpload()
                }).catch(()=>{})
            }
            else{
                this.curShowSet.width = 0
                this.curUploadIndex = 0
                this.hideFlag = true
                this.isUploading = false
                this.isFinished = false
                setTimeout(()=>{
                    this.uploadingList = []
                },250)
            }
        },
        autoUploadNew(){
            let bool = true
            this.isUploading = false
            for(let nIndex in this.uploadingList){
                let nItem = this.uploadingList[nIndex]
                if(nItem.status == 'WAITING'){
                    this.curUploadIndex  = Number(nIndex) + 1
                    this.formalUpload(this.uploadingList[nIndex],this.uploadingList[nIndex].curChunkId)
                }
                if(nItem.status != 'FINISHED'){
                    bool = false
                }
            }
            this.isFinished = bool
        },
        stopUploading(item){
            if(item.status == 'UPLOADING'){
                item.status = 'STOPING'
                this.stopObj[item.fileId] = true
            }
            if(item.status == 'WAITING'){
                item.status = 'STOP'
                this.stopObj[item.fileId] = true
            }
        },
        startUploading(item){
            if(item.status == 'STOP' || item.status == 'ERROR'){
                this.stopObj[item.fileId] = false
                this.$http.post(this.$api.file.recoverUpload,{
                    fcLfId:item.fileId,
                }).then(res=>{
                    item.curChunkId = res.payload.fileChunks.fc_id
                    if(!this.isUploading){
                        item.status = 'UPLOADING'
                        if(res.payload.fileChunks && res.payload.fileChunks.fc_id){
                            this.formalUpload(item,res.payload.fileChunks.fc_id) 
                        }
                    }
                    else{
                        item.status = 'WAITING'
                    }

                })

            }
        },
        delUploading(item,index){
            if(item.status == 'FINISHED'){
                this.uploadingList.splice(index,1)
            }
            else{
                this.$confirm('该文件未上传成功,取消上传会导致文件预览失败，是否继续?', '取消上传', {
                    confirmButtonText: '取消上传',
                    cancelButtonText: '继续上传',
                    type: 'error'
                }).then(() => {
                    this.$http.post(this.$api.file.cancelUpload,{
                        fcLfId:[item.fileId]
                    }).then(()=>{
                        this.stopObj[item.fileId] = true
                        if(this.uploadingList.length == 1){
                            this.curShowSet.width = 0
                            this.curUploadIndex = 0
                            this.hideFlag = true
                            this.isUploading = false
                            this.isFinished = false
                            setTimeout(()=>{
                                this.uploadingList = []
                            },250)
                        }
                        else{
                            this.uploadingList.splice(index,1)
                            this.autoUploadNew()
                        }
                    })
                }).catch(()=>{

                })
            }
        },
        startAllUpload(){
            this.isAllStop = false
            for(let item of this.uploadingList){
                this.startUploading(item)
            }
        },
        stopAllUpload(){
            this.isAllStop = true
            for(let item of this.uploadingList){
                this.stopUploading(item)
            }
        },
        cancelUpload(){
            let fileList = []
            for(let item of this.uploadingList){
                if(item.status != 'FINISHED'){
                    fileList.push(item.fileId)
                }
            }
            if(fileList.length == 0){
                return
            }
            this.$http.post(this.$api.file.cancelUpload,{
                fcLfId:fileList
            })
        },
        logText(text){
            console.log(text);
        },
        toPreViewFile(item){
            // this.$message({
            //     type: "success",
            //     message: "暂不支持预览",
            // });
            // return
            let obj = {
                file_name:item.name,
                file_id:item.fileId,
            }
            this.fileList = [obj]
            this.showPreView = true
        }
    },
};
</script>

<style lang="scss" scoped>
.uploadDailog_box{
    position: fixed;
    right: 30px;
    bottom: 30px;
    z-index: 12999;
    width: 440px;
    box-sizing: border-box;
    box-shadow: 0px 4px 30px 0px #70798E59;
    background-color: #fff;
    border-radius: 4px;
    animation: showBy 0.25s linear;
    transition: all 0.25s;
    overflow: hidden;
    .uploadDailog_body{
        .uploadDailog_header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 45px;
            border-bottom: 1px solid #e1e1e5;
            padding: 0 15px;
            font-weight: bold;
            color: #303033;
            .uploadDailog_iconBtn{
                display: flex;
                align-items: center;
            }
            i{
                cursor: pointer;
                color: #A1A2AB;
                margin-left: 10px;
                font-weight: normal;
                font-size: 20px;
                &:first-child{
                    font-size: 14px;
                }
                &:hover{
                    color: var(--mainColor);
                }
            }
        }
        .uploadDailog_itemList{
            max-height: 260px;
            overflow-y: auto;
            overflow-x: hidden;
            transition: all 0.25s;
            .uploadDailog_item{
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 65px;
                padding: 20px;
                box-sizing: border-box;
                cursor: pointer;
                border-bottom: 1px solid #F2F2F2;
                animation: faceIn 0.25s;
                @keyframes faceIn{
                    0%{
                        transform: translateX(100%);
                    }
                    100%{
                        transform: translateX(0);
                    }
                }
                &:hover{
                    background-color: #F0F0F5;
                }
                .uploadDailog_itemLeft{
                    display: flex;
                    align-items: center;
                    width: 50%;
                    .uploadDailog_itemType{
                        margin-right: 10px;
                        display: flex;
                        align-items: center;
                        img{
                            height: 26px;
                        }
                    }
                    .uploadDailog_itemInfo{
                        font-size: 14px;
                        color: #303033;
                        width: 100%;
                        div{
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            width: 100%;
                            &:last-child{
                                font-size: 12px;
                                color: #909099;
                            }
                        }
                    }
                }
                .uploadDailog_itemRight{
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    .uploadDailog_itemProess{
                        display: flex;
                        align-items: center;
                        padding-right: 16px;
                        border-right: 1px solid #E1E1E5;
                        .loading{
                            margin-right: 6px;
                            animation: turnRound 8s linear infinite;
                        }
                        .stop{
                            margin-right: 6px;
                        }
                        i{
                            margin-right: 6px;
                        }
                        .green{
                            color: #33cc85;
                        }
                        .red{
                            color: red;
                        }
                        .yellow{
                            color: #ff7512;
                        }
                        @keyframes turnRound {
                            0%{
                                transform: rotateZ(0deg);
                            }
                            100%{
                                transform: rotateZ(3600deg);
                            }
                        }
                    }
                    .uploadDailog_itemBtn{
                        i{
                            margin-left: 16px;
                            color: #909099;
                            font-size: 14px;
                        }
                        img{
                            margin-left: 16px;
                        }
                    }
                }
            }
        }
        .uploadDailog_bottomBox{
            background-color: #F5F6F7;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;
            .uploadDailog_loading{
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #303033;
                white-space: nowrap;
                overflow: hidden;
                img{
                    margin-right: 6px;
                    animation: turnRound 8s linear infinite;
                }
                span{
                    white-space: nowrap;
                }
                i{
                    margin-right: 6px;
                    font-size: 16px;
                }
                .green{
                    color: #33cc85;
                }
                .red{
                    color: red;
                }
                .yellow{
                    color: #ff7512;
                }
                @keyframes turnRound {
                    0%{
                        transform: rotateZ(0deg);
                    }
                    100%{
                        transform: rotateZ(3600deg);
                    }
                }
            }
            .uploadDailog_bottomBtn{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                font-size: 14px;
                cursor: pointer;
                color: #606066;
                width: 50%;
                overflow: hidden;
                div{
                    margin-left: 20px;
                    white-space: nowrap;
                    overflow: hidden;
                }
            }
        }
    }
    .uploadDailog_body_hide{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        border-bottom: 1px solid #e1e1e5;
        padding: 0 20px;
        color: #303033;
        .uploadDailog_loading{
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #303033;
            span{
                white-space: nowrap;
            }
            img{
                margin-right: 6px;
                animation: turnRound 8s linear infinite;
            }
            i{
                margin-right: 6px;
                font-size: 16px;
            }
            .green{
                color: #33cc85;
            }
            .red{
                color: red;
            }
            .yellow{
                color: #ff7512;
            }
            @keyframes turnRound {
                0%{
                    transform: rotateZ(0deg);
                }
                100%{
                    transform: rotateZ(3600deg);
                }
            }
        }
        .uploadDailog_iconBtn{
            display: flex;
            align-items: center;
        }
        i{
            cursor: pointer;
            color: #A1A2AB;
            margin-left: 10px;
            font-weight: normal;
            font-size: 20px;
            &:hover{
                color: var(--mainColor);
            }
        }
    }
}
@keyframes showBy {
    0%{
        transform: translateX(100%);
        opacity: 0.5;
    }
    100%{
        transform: translateX(0%);
        opacity: 1;
    }
}
</style>